<template>
  <div class="layout">
    <layout-header />
    <router-view />
    <layout-rooter />
    <div class="to-top" style="display: none" @click="toTop">TOP</div>
  </div>
</template>

<script>
import LayoutHeader from './LayoutHeader'
import LayoutRooter from './LayoutFooter'
export default {
  name: 'LayoutRouter',
  components: {
    LayoutHeader,
    LayoutRooter
  },
  data() {
    return {
      obServer: null
    }
  },
  methods: {
    toTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    },
    initObserver() {
      this.obServer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const img = entry.target
              const src = img.dataset.src
              if (src) {
                img.src = src
                img.removeAttribute('data-src')
                this.obServer.unobserve(img)
              }
            } else {
              entry.target.classList.remove('active')
            }
          })
        },
        {
          rootMargin: '0px 0px 200px 0px', // 提前200px加载
          threshold: 0.1
        }
      )
    },
    toggleToTop() {
      if (window.scrollY > 100) {
        document.querySelector('.to-top').style.display = 'block'
      } else {
        document.querySelector('.to-top').style.display = 'none'
      }
    }
  },
  mounted() {
    window.addEventListener('scroll', this.toggleToTop)
    this.initObserver()
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.toggleToTop)
    this.obServer.disconnect()
  }
}
</script>
<style lang="less" scoped>
.layout {
  width: 100%;
}
.to-top {
  position: fixed;
  bottom: 20px;
  right: 40px;
  height: 40px;
  width: 40px;
  border-radius: 50%;
  background-color: #d2153d;
  box-shadow: 0 0 6px 0 rgba(0, 0, 0);
  cursor: pointer;
  color: white;
  line-height: 40px;
  text-align: center;
  &:hover {
    animation: jump 0.5s ease-in-out infinite;
  }
}
@keyframes jump {
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
  100% {
    transform: translateY(0);
  }
}
</style>
